import {ProcessStageTitle} from '@hconnect/common/components'
import {useProcessStages} from '@hconnect/common/hooks/useProcessStages'
import {FilterMultiSelect, FilterMultiSelectProps} from '@widgets/common-filters'

import {FILTER_VALUE_SEPARATOR} from '../../consts'

export const TaskProcessStageFilter = <TName extends string>(
  props: Omit<FilterMultiSelectProps<string, TName>, 'options'> & {plantId: string}
) => {
  const {plantId} = props
  const {data: processStagesMap} = useProcessStages(plantId)
  const options = processStagesMap
    ? Array.from(processStagesMap).map(([value, label]) => ({value, label}))
    : []

  return (
    <FilterMultiSelect
      {...props}
      options={options}
      getOptionLabel={({value}) => <ProcessStageTitle stages={processStagesMap} stage={value} />}
      renderValue={(value) => {
        return value
          .map((processStage) => (processStagesMap ? processStagesMap.get(processStage) : ''))
          .join(FILTER_VALUE_SEPARATOR)
      }}
    />
  )
}
